module.exports = __webpack_public_path__ + "static/media/document_image.7d5d1b71.jpg";